import { compose } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import React, { useCallback, useEffect, useState } from 'react';
import { withComponent } from 'js/components/hocs/withComponent';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { componentService } from 'js/services/component.service';
import { getPlayerTags, setPlayerTags } from 'js/hooks/user/server';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';

import { CLOSE_ACCOUNT_TAG } from './constants';

import style from './CloseAccount.scss';

export const CloseAccountBare = () => {
    const t = useTranslations();
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isClosed, setIsClosed] = useState(false);
    const showConfirmationPopup = useConfirmationPopup();
    const { showComponentError } = useComponentMethods();

    const onClose = useCallback(async () => {
        try {
            setIsLoaded(false);
            await setPlayerTags([{ name: CLOSE_ACCOUNT_TAG }]);

            const { data = {} } = await getPlayerTags(CLOSE_ACCOUNT_TAG);

            setIsClosed(data.tags?.length === 1);
            setIsLoaded(true);
        } catch (e) {
            setError(true);
            setIsLoaded(false);
        }
    }, []);

    const onClick = useCallback(() => {
        showConfirmationPopup({
            isModal: false,
            onAccept: onClose,
            className: 'close-account-confirm-popup',
            acceptBtnText: 'playtech.mobile.system.closeAccount.confirmClose',
            declineBtnText: 'playtech.mobile.system.closeAccount.cancelClose',
            content: 'playtech.mobile.system.closeAccount.confirmation'
        });
    }, [showConfirmationPopup, onClose]);

    useEffect(() => {
        let isSubscribed = true;

        (async () => {
            try {
                const { data = {} } = await getPlayerTags(CLOSE_ACCOUNT_TAG);

                if (isSubscribed) {
                    setIsClosed(data.tags?.length === 1);
                    setIsLoaded(true);
                }
            } catch (e) {
                showComponentError(t('playtech.mobile.system.closeAccount.error'));
            }
        })();

        return () => isSubscribed = false;
    }, [setIsClosed, showComponentError, t]);

    return (
        <div className={style.content}>
            {error && (
                <ErrorMessage
                    className={style.error}
                    message={'playtech.mobile.system.closeAccount.error'}
                />
            )}
            <p className={style.description}>{t(`playtech.mobile.system.closeAccount.${isClosed ? 'isClosed' : 'isOpen'}`)}</p>
            <Button
                onClick={onClick}
                disabled={!isLoaded || isClosed}
                className={`${style.button} btn`}
            >
                {t('playtech.mobile.system.closeAccount.closeAccount')}
            </Button>
        </div>
    );
};

export const CloseAccount = compose(
    withComponent({ isForLoggedIn: true })
)(CloseAccountBare);

componentService.registerWebContentComponents({ CloseAccount });
